import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DeleteConfirmationModal from "../../../components/commonComponent/DeleteConfirmationModal";
import Pagination from "../../../components/commonComponent/Pagination";
import Search from "../../../components/commonComponent/Search";
import Table from "../../../components/commonComponent/Table";
import { TOAST_MESSAGES } from "../../../constants/SiteConstants";
import useFetchUserOptions from "../../../hooks/useFetchUserOptions";
import useModal from "../../../hooks/useModal";
import "../../../styles/Form.css";
import { fetchData, getCurrentData } from "../../../utils/utils";
import useLoader from "../../../hooks/useLoader";

const API_URL = process.env.REACT_APP_API_URL;
const ITEMS_PER_PAGE = 10;

const Question = () => {
  const [questions, setQuestions] = useState([]);
  const navigate = useNavigate();
  const users = useFetchUserOptions();
  const [searchTerm, setSearchTerm] = useState("");
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [filteredData, setFilteredData] = useState([]);
  const { loading, showLoader, hideLoader } = useLoader();

  const {
    showDeleteModal,
    selectedItem,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
  } = useModal();

  useEffect(() => {
    if (searchTerm.length >= 2 || searchTerm === "") {
      fetchData(
        `${API_URL}/questions/getAllQuestion`,
        setQuestions,
        setError,
        setFilteredData,
        currentPage,
        searchTerm,
        showLoader,
        hideLoader
      );
    }
  }, [currentPage, searchTerm]);

  const getUsernameById = (row) => {
    const user = users.find((u) => u._id === row.userId);
    return user ? user.fullName : "Unknown User";
  };

  const columns = [
    { header: "Title", accessor: "title" },
    { header: "Username", render: getUsernameById },
  ];

  const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);
  const currentData = getCurrentData(filteredData, currentPage, ITEMS_PER_PAGE);

  const handleSearch = (searchValue) => {
    if (searchValue.length >= 2) {
      setSearchTerm(searchValue);
      setCurrentPage(1);
    } else if (searchValue.length === 0) {
      setSearchTerm("");
      setCurrentPage(1);
    }
  };

  const handleDelete = async () => {
    try {
      if (!selectedItem) return;

      await axios.delete(
        `${API_URL}/questions/deleteQuestionById/${selectedItem._id}`
      );
      setQuestions(
        questions.filter((question) => question._id !== selectedItem._id)
      );
      fetchData(
        `${API_URL}/questions/getAllQuestion`,
        setQuestions,
        setError,
        setFilteredData,
        currentPage,
        searchTerm,
        showLoader,
        hideLoader
      );
      handleCloseDeleteModal();
      toast.success(TOAST_MESSAGES.DELETED, {});
    } catch (error) {
      toast.error(TOAST_MESSAGES.ERROR_DELETE, {
        autoClose: 1000,
      });
    }
  };

  return (
    <div>
      <h2 className="capitalize font-bold text-[24px] mb-4">Q&A</h2>

      <div className="flex justify-between items-center shadow-md px-8 py-[10px] rounded-md bg-[#fff] text-base mb-4">
        <div className="flex items-center">
          <div className="search-filter-container">
            <Search
              searchFields={["First Name", "Last Name", "Email"]}
              onSearch={handleSearch}
            />
          </div>
        </div>

        <Link
          to="/questions/add"
          className="inline-flex items-center justify-center rounded-md border border-white px-4 py-1.5 text-center font-medium text-white bg-[#1C2434] hover:bg-opacity-90"
        >
          Add Question
        </Link>
      </div>
      <div className="table-container">
        <Table
          columns={columns}
          data={currentData}
          showIndex={true}
          currentPage={currentPage}
          itemsPerPage={ITEMS_PER_PAGE}
          onDelete={handleOpenDeleteModal}
          onUpdate={(item) => navigate(`/questions/edit/${item._id}`)}
          actions={{
            showEdit: true,
            showDelete: true,
          }}
          loading={loading}
        />
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>

      <DeleteConfirmationModal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onConfirm={handleDelete}
      />
    </div>
  );
};

export default Question;
